import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';

import { StoreContext } from '../store/StoreProvider';
import { isEmpty } from '../commons/utils';
import Header from '../main/Header';
import Footer from '../main/Footer';

const RouteProtectedHoc = ({ component: Component, ...rest }) => {
	// To avoid page go to homepage when refreshing it
	const isLogin = JSON.parse(localStorage.getItem('isLogin'));

	// eslint-disable-next-line no-unused-vars
	const [state, _] = useContext(StoreContext);

	const { user } = state;

	if (isLogin || !isEmpty(user) || rest.public) {
		return (
			<div style={{ height: '100%' }}>
				{rest.withHeader && <Header />}
				{Component && <Route {...rest} render={(props) => <Component {...props} />} />}
				{rest.withFooter && <Footer />}
			</div>
		);
	}
	return null;
};

// RouteProtectedHoc.propTypes = {
// 	component: PropTypes.node,
// 	isLoggedIn: PropTypes.bool,
// };
//
// RouteProtectedHoc.defaultProps = {
// 	component: null,
// 	isLoggedIn: false,
// };

export default RouteProtectedHoc;
